import { queryClient } from '../queryClient';

/** Remove every server response associated with the authenticated account. */
export function clearAuthenticatedSessionCache(): void {
  queryClient.clear();
}
